export class TipoDado {
    tipoDadoId: number;
    nome: string;

    constructor(dtoTipoDado: any) {
        this.nome = dtoTipoDado.nome;
        this.tipoDadoId = dtoTipoDado.tipoDadoID;
    }
}
